const navBtn = document.querySelector('#navBtn');
const nav = document.querySelector('#nav');
const secondaryNavLinks = document.querySelectorAll('.secondaryNavLink');
const navImage = document.querySelector('#navImage');
const navListBtns = document.querySelectorAll('.navListBtn');
const searchContainer = document.querySelector('#searchContainer');
const searchTrigger = document.querySelector('#searchTrigger');
const searchAgain = document.querySelector('#search-again');

if (navBtn) {

	navBtn.addEventListener('click', () => {
		navBtn.classList.toggle('is-active');
		nav.classList.toggle('is-active');
		searchContainer.classList.toggle('is-active');
	})
}

if (navListBtns) {

	navListBtns.forEach((item) => {
		item.addEventListener('click', () => {
			item.classList.toggle('is-active');
			item.nextElementSibling.classList.toggle('is-active');
		})
	})
}

if (secondaryNavLinks) {

	secondaryNavLinks.forEach((item) => {
		const image = item.dataset.image;

		if (image) {
			item.addEventListener('mouseover', () => {
				navImage.src = image;
			})
		}
	})
}

if (searchTrigger) {
	searchTrigger.addEventListener('click', () => {
		activeSearchContainer()
	});
}

if (searchAgain) {
	searchAgain.addEventListener('click', () => {
		activeSearchContainer()
	});
}

function activeSearchContainer() {
	if (searchTrigger) {
		searchTrigger.classList.toggle('is-active');
	}

	if (searchContainer) {
		searchContainer.classList.toggle('is-active');
	}
}
